export default __webpack_public_path__ + "static/media/656.fe03324a.png";